import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { endpoints } from '../../config/connections';
import './Scans.css'
import { writeFile, utils } from '@e965/xlsx';
import { ConfigConstantsContext } from '../components/Hooks/useConfigConstants';
import rateLimit from 'axios-rate-limit';
import SummaryComponent from './SummaryCount';
import LoadingPage from './LoadingPage';
import './LoadingPage.css';
import { v4 as uuidv4 } from 'uuid';
import DropdownMenu from './DropdownMenu';
import _noaccess from './_noaccess';
const Scans = () => {
    const allowedHosts = ['localhost', 'it1-docmanagement.us.bank-dns.com'];
    const isAllowedHost = allowedHosts.includes(window.location.hostname);

    const { configDetails, loading } = useContext(ConfigConstantsContext)
    const [projectData, setProjectData] = useState([]);
    const [originalData,setOriginalData]=useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isEmailDivVisible, setIsEmailDivVisible] = useState(false);
    const [haveAllURLS,setHaveAllURLS]=useState(false);
        const [showConfirmBulk, setShowConfirmBulk] = useState(false);
        const [toasts, setToasts] = useState([]);
    const [mrOpenCount, setMrOpenCount] = useState(null);
    const [mrList, setMrList] = useState([]);
    const [mrLoading, setMrLoading] = useState(false);
    const [showMRModal, setShowMRModal] = useState(false);

        const addToast = (msg) => {
            const id = uuidv4();
            setToasts((prev) => [...prev, { id, msg }]);
            // Auto-dismiss after 15 seconds
            setTimeout(() => removeToast(id), 15000);
        };
        const removeToast = (id) => setToasts((prev) => prev.filter((t) => t.id !== id));

        const fetchOpenMRs = async () => {
            // Fetch open Merge Requests for the GitLab group; fall back to opening the GitLab page if blocked
            setMrLoading(true);
            try {
                const resp = await axios.get(
                    `${endpoints.apigee}/document-management/cdc/requirements/v1/gitlab/merge-requests?groupPath=DOC-MANAGEMENT/apis&state=opened`
                );
                const mrs = resp?.data?.data ?? resp?.data ?? [];
                const count = Array.isArray(mrs) ? mrs.length : (resp?.data?.count ?? 0);
                setMrList(Array.isArray(mrs) ? mrs : []);
                setMrOpenCount(count);
                setShowMRModal(true);
            } catch (error) {
                addToast('Unable to fetch MRs. Opening GitLab group instead.');
                openInNewTabNoFocus('https://gitlab.us.bank-dns.com/groups/DOC-MANAGEMENT/apis/-/merge_requests');
            } finally {
                setMrLoading(false);
            }
        };

        // Prefetch open MR count so the button shows a number before clicking
        useEffect(() => {
            const prefetchCount = async () => {
                try {
                    const resp = await axios.get(
                        `${endpoints.apigee}/document-management/cdc/requirements/v1/gitlab/merge-requests?groupPath=DOC-MANAGEMENT/apis&state=opened`
                    );
                    const mrs = resp?.data?.data ?? resp?.data ?? [];
                    const count = Array.isArray(mrs) ? mrs.length : (resp?.data?.count ?? 0);
                    setMrOpenCount(count);
                } catch (e) {
                    // silent: leave as em dash if we can't prefetch
                }
            };
            prefetchCount();
        }, []);
    // const [hardcodedArray, setHardcodedArray] = useState([
    //     {
    //         id: '38660',
    //         value: 'Document Requirements',
   // keywords:'coreservice,requriemewnt',
    //         gitUrl: 'https://gitlab.us.bank-dns.com/DOC-MANAGEMENT/apis/usb-service-tos-document-requirements/-/tree/develop?ref_type=heads',
    //         sonarURL: 'https://sonarqube.us.bank-dns.com/dashboard?id=INTERACTION-MANAGEMENT%3ADocMgtDocumentRequirements',
    //         jenkinURL: 'https://cloudbees.us.bank-dns.com/controller-17/job/IDC_OLB_ALL/job/entrp_services_capabilities/job/CDC_apis/job/CDC_APIs/job/usb_service_tos_document_requirements/build?delay=0sec',
    //         splunkURL: 'https://elosusbaws.splunkcloud.com/en-US/app/search/cdc-uat-dashboard?form.Time_Range.earliest=-24h%40h&form.Time_Range.latest=now&form.environment=prod_k8s_onprem_digital-obc-k8-prod1&form.appName=kube%3Acontainer%3Ausb-service-tos-document-requirements&form.search=*',
    //         rancherURL: 'https://rancher-test1.us.bank-dns.com/dashboard/c/c-fdvz2/explorer/apps.deployment?q=usb-service-tos-document-requirements',
    //     },
    // ]);

    
    const [categoryConfigs,setCategoryConfigs] = useState({})
    
    
    
    // const isSaveAllowed = categoryConfigs["save"]!=undefined ? categoryConfigs["save"] : true;

    useEffect(() => {
        const fetchData = async () => {
            try {


                // Fetch the array of projects
                const projectsResponse = await axios.get(`${endpoints.apigee}/document-management/cdc/requirements/v1/fortify-projects`);
                const projects = projectsResponse.data?.data;

                // Create an array of promises for additional data
                const dataPromises = projects
                   
                    // .slice(0,10)
                    // 38654,38655,38656
                    // .filter(project=> [38660,38664,38649,38650,38651,38652,38653,,38646,38655,38656,38657,38658,38659,38661,38662,38663,38665,38666,38648,38999].includes(project.id))
                // .filter(project=> [38646,38660,38664,38649,38650,38651,38652,38653,38646,38657].includes(project.id))
                    // .filter(project => project.id == "38660"||project.id == "38646"||project.id == "38664")
                    ?.map(async project => {
                        
                        const response = await axios.get(`${endpoints.apigee}/document-management/cdc/requirements/v1/fortify-reports/${project.id}`);
                        console.log(project.id,'->' ,response.data?.data?.length);   
                         
                        if(response.data?.data?.length==0){
                        return {
                            id: project.id,
                            name: project.name,
                            lowCount: 0,
                            mediumCount: 0,
                            highCount: 0,
                            fPCount: 0,
                            creationDate:  null,
                        };    
                    }  else{                                            
                        return {
                            id: project.id,
                            name: project.name,
                            lowCount: response.data?.data?.find(res => res.id == "Low")?.visibleCount || 0,
                            mediumCount: response.data?.data?.find(res => res.id == "Moderate")?.visibleCount || 0,
                            highCount: response.data?.data?.find(res => res.id == "High")?.visibleCount || 0,
                            fPCount: response.data?.data?.find(res => res.id == "False Positive")?.visibleCount || 0,
                            creationDate: project?.currentState?.metricEvaluationDate || new Date().toISOString(),
                        };
                    }
                    })
                    // ?.filter(project => project.creationDate != null);
                    

                
                let resolvedData = await Promise.all(dataPromises);
     
                setProjectData(resolvedData);
                setOriginalData(resolvedData);
               
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        
       
            fetchData();
            


    }, []);


    useEffect(()=>{
        if(configDetails != {} && projectData?.length>0){
        let tempproject= projectData.map(project=>{
            console.log(project.id);
        const configURL=configDetails[project.id]?JSON.parse(configDetails[project.id]):{};
        setHaveAllURLS(true);
        return {...project,configURLs:configURL}
        }
    ) 
    setProjectData(tempproject);    
    setIsLoading(false);  
        }
      }
      ,[configDetails,originalData])

useEffect(()=>{

    const fetchData = async () => {
        try {
          const initialData = projectData;
          // Call the second API for each project and append the response
          const updatedData = await Promise.all(
            initialData.map(async (project) => {

                const configURL=configDetails[project.id]?JSON.parse(configDetails[project.id]):{};
                
                let appstatus="";
                let freeMemoryPercentage = "";
        
                    if(configURL?.statusURL){
                        const config = {
                            headers: {
                                     Accept: 'application/json',
                                'Correlation-ID': `${sessionStorage.getItem(
                                  'loggedUser'
                                )} ${sessionStorage.getItem('correlationId')}`,
                                'Client-Application': 'CDC',
                                'jwt': `${sessionStorage.getItem('tok')}`,
                                'user-id': `${sessionStorage.getItem('assignedUser')}`,
                                Authorization: `Bearer ${sessionStorage.getItem('at')}`,
                            }
                          };
                          
                         await axios.get(configURL?.statusURL, config)
                            .then(response => {
                                if(response.status==200){
                                
                                 const data=response?.data;
                                 appstatus=data.status;
                                 const totalMemory = data.components.diskSpace.details.total;
                                 const freeMemory = data.components.diskSpace.details.free;
                                 freeMemoryPercentage = ((freeMemory / totalMemory) * 100).toFixed(2) + '%';
        

                                }
                                else{
                                    appstatus="DOWN";
                                    freeMemoryPercentage="-"
                                }
                                
               
                            })
                            .catch(error => {
                              console.error('Error fetching health data:'); 
                              });
                        }


              return {...project,appstatus,freeMemoryPercentage}
            })
          );
          setProjectData(updatedData);
        } catch (error) {
          console.error('Error fetching project data:', error);
        }
      };

      const fetchEDMStatus = async () => {

        let appstatusEDMTmp="";
        let freeMemoryPercentageEDMTmp = "";

        const config = {
            headers: {
                     Accept: 'application/json',
                'Correlation-ID': `${sessionStorage.getItem(
                  'loggedUser'
                )} ${sessionStorage.getItem('correlationId')}`,
                'Client-Application': 'CDC',
                'jwt': `${sessionStorage.getItem('tok')}`,
                'user-id': `${sessionStorage.getItem('assignedUser')}`,
                Authorization: `Bearer ${sessionStorage.getItem('at')}`,
            }
          };
          
         await axios.get(`${endpoints.apigee}/document-management/cdc/requirements/v1/edmHealth`)
            .then(response => {
                if(response.status==200){
                
                 const data=response?.data;
                 appstatusEDMTmp=data.status;
                 const totalMemory = data.components.diskSpace.details.total;
                 const freeMemory = data.components.diskSpace.details.free;
                 freeMemoryPercentageEDMTmp = ((freeMemory / totalMemory) * 100).toFixed(2) + '%';

                }
                else{
                    appstatusEDMTmp="DOWN";
                    freeMemoryPercentageEDMTmp="-"
                }
                
            setAppstatusEDM(appstatusEDMTmp);
            setFreeMemoryPercentageEDM(freeMemoryPercentageEDMTmp);
            })
            .catch(error => {
              console.error('Error fetching health data:'); 
              });
            }


      if(!isLoading && haveAllURLS){
      fetchData();
      fetchEDMStatus();
      setHaveAllURLS(false);
      setTimeout(() => {
        setHaveAllURLS(true);
      }, 100000);
      }
},[isLoading,haveAllURLS])


    const mainDivRef = useRef(null);
    const divRef = useRef(null);

    const copyToClipboard = () => {
        setIsEmailDivVisible(true);

        setTimeout(() => {
            const content = divRef.current.innerText;
            const now = new Date();
            const formattedDateTime = now?.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
            navigator.clipboard.writeText(content).then(() => {
                window.location.href = `mailto:CDCPortalTOS@usbank.com;?subject=Vulnerability report for CDC-Impact Finance ${formattedDateTime} &body=${encodeURIComponent(content)}`;
                setIsEmailDivVisible(false);
            }).catch(err => {
                console.error('Failed to copy content: ', err);
                setIsEmailDivVisible(false);
            });
        }, 500);

    }


    const [selectedRowId, setSelectedRowId] = useState(null);
    const [appstatusEDM, setAppstatusEDM] = useState("");
    const [freeMemoryPercentageEDM, setFreeMemoryPercentageEDM] = useState("");

    const [filter, setFilter] = useState("");

    // Sorting: default to Report Date descending
    const [sortConfig, setSortConfig] = useState({ column: 'creationDate', direction: 'desc' });

    const handleSort = (column) => {
        setSortConfig((prev) => {
            if (prev.column === column) {
                return { column, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
            }
            const defaultDir = column === 'highCount' ? 'desc' : 'asc';
            return { column, direction: defaultDir };
        });
    };

    const renderSortIcon = (column) => {
        if (sortConfig.column !== column) return null;
        return sortConfig.direction === 'asc' ? ' ▲' : ' ▼';
    };

    const getComparableValue = (row, column) => {
        switch (column) {
            case 'id':
                return Number(row.id) || 0;
            case 'project':
                return row?.configURLs?.value || row?.name || '';
            case 'appstatus':
                return row?.appstatus || '';
            case 'creationDate':
                return row?.creationDate ? new Date(row.creationDate).getTime() : 0;
            case 'highCount':
                return row?.highCount ?? 0;
            case 'mediumCount':
                return row?.mediumCount ?? 0;
            case 'lowCount':
                return row?.lowCount ?? 0;
            default:
                return '';
        }
    };

    const sortData = (data) => {
        const dir = sortConfig.direction === 'asc' ? 1 : -1;
        const col = sortConfig.column;
        return [...(data || [])].sort((a, b) => {
            const av = getComparableValue(a, col);
            const bv = getComparableValue(b, col);
            if (typeof av === 'string' || typeof bv === 'string') {
                return dir * String(av).localeCompare(String(bv));
            }
            return dir * (av - bv);
        });
    };

    const handleSingleSelect = (id) => {
        setSelectedRowId(id);
        alert(`Building Jenkins pipeline for project ${id} with fortify and blackduck on develop branch.`);
    }

    const openFortifyPage = (id) => {
        const url = `https://ssc.usbank.fortifyhosted.com/html/ssc/version/${id}/audit?filterset=aee53aff-c2be-4097-8004-9746b40a729f&orderby=friority&viewTab=code`;
        window.open(url, '_blank');
    };

    const openInNewTabNoFocus = (url) => {
        try {
            const a = document.createElement('a');
            a.href = url;
            a.target = '_blank';
            a.rel = 'noopener noreferrer';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            // Attempt to retain focus on current page
            setTimeout(() => window.focus(), 0);
        } catch (err) {
            window.open(url, '_blank');
        }
    };

    const openReScanById = (id, delayMs = 0) => {
        const cfg = projectData?.find(project => id === project.id)?.configURLs || {};
        if (cfg?.buildTriggerURL) {
            setTimeout(() => {
                try {
                    openInNewTabNoFocus(cfg.buildTriggerURL);
                    addToast(`Triggered build for project ${id}`);
                } catch (err) {
                    addToast(`Failed to open build trigger for project ${id}`);
                }
                if (cfg?.buildStatusURL) {
                    setTimeout(() => {
                        try {
                            openInNewTabNoFocus(cfg.buildStatusURL);
                            addToast(`Opened build status for project ${id}`);
                        } catch (err) {
                            addToast(`Failed to open build status for project ${id}`);
                        }
                    }, 1000);
                }
            }, delayMs);
        }
    };

    const openReScan = (e,id) => {
        e.preventDefault();
        e.stopPropagation();
        openReScanById(id);
    };

    const openURL = (e,id, type) => {
        e.preventDefault();
        e.stopPropagation();
        if (type == "git") {
            window.open(projectData?.filter(project => id == project.id)[0]?.configURLs?.gitUrl, '_blank');
        } else if (type == "splunk") {
            window.open(projectData?.filter(project => id == project.id)[0]?.configURLs?.splunkURL, '_blank');
        } else if (type == "rancher") {
            window.open(projectData?.filter(project => id == project.id)[0]?.configURLs?.rancherURL, '_blank');
        } else if (type == "jenkins") {
            window.open(projectData?.filter(project => id == project.id)[0]?.configURLs?.jenkinURL, '_blank');
        } if (type == "sonar") {
            window.open(projectData?.filter(project => id == project.id)[0]?.configURLs?.sonarURL, '_blank');
        } else if (type === "statusURL") {
            window.open(projectData?.filter(project => id == project.id)[0]?.configURLs?.statusURL, '_blank');
        }

    }

    const [selectedRowIds, setSelectedRowIds] = useState([]);

    const handleCheckboxClick = (id) => {
        setSelectedRowIds((prevSelectedRowIds) => {
            if (prevSelectedRowIds.includes(id)) {
                // Remove the ID if it's already selected
                return prevSelectedRowIds.filter((rowId) => rowId !== id);
            } else {
                // Add the ID if it's not already selected
                return [...prevSelectedRowIds, id];
            }
        });
    };

    const triggerBulkReScan = () => {
        if (!selectedRowIds || selectedRowIds.length === 0) {
            addToast('Select at least one project to build & re-scan.');
            return;
        }
        setShowConfirmBulk(true);
    };

    const runBulkReScan = () => {
        // Stagger requests slightly to avoid overwhelming
        selectedRowIds.forEach((id, idx) => {
            const delay = idx * 300; // 0.3s gap between triggers
            openReScanById(id, delay);
        });
        addToast(`Initiated Build & Re-Scan for ${selectedRowIds.length} project(s).`);
        setShowConfirmBulk(false);
    };

    ([]);
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);


    const handleSelectAllClick = () => {
        if (isSelectAllChecked) {
            // Unselect all rows
            setSelectedRowIds([]);
        } else {
            // Select all rows
            const allRowIds = projectData?.map((row) => row.id);
            setSelectedRowIds(allRowIds);
        }
        setIsSelectAllChecked(!isSelectAllChecked);
    };

    const exportToExcel = () => {
        setIsEmailDivVisible(true);

        setTimeout(() => {
            // Get the content from the div
            const data = Array.from(mainDivRef.current.querySelectorAll('tr')).map(row =>
                Array.from(row.querySelectorAll('td, th')).map(cell => cell.textContent)
            );

            // Create a new workbook and add the data
            const worksheet = utils.aoa_to_sheet(data);
            const workbook = utils.book_new();
            utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            // Get the current date and time
            const now = new Date();
            const formattedDateTime = now?.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });

            // Export the workbook to an Excel file with the current date and time in the name
            writeFile(workbook, `export_${formattedDateTime}.xlsx`);
            setIsEmailDivVisible(false);
        }, 500);

    };
    function sumByKey(items, key) {
         const sum = items.reduce((accumulator, currentItem) => {
            return accumulator + currentItem.key;
        }, 0);

        return sum;
    }

    if (!isAllowedHost) {
        return <_noaccess/>;
    }

    return isLoading ? <LoadingPage/> : (
        <div className="scans-page">
            <div ref={mainDivRef}>
                                <br></br>
<div className="scans-header">
    <h1>DevSecOps Dashboard - Unified API Monitoring & Vulnerability Management</h1>
</div>
<br></br>
             


<div className="scans-controls">
        <DropdownMenu setFilter={setFilter} appstatusEDM={appstatusEDM} freeMemoryPercentageEDM={freeMemoryPercentageEDM} filter={filter} copyToClipboard={copyToClipboard} exportToExcel={exportToExcel} triggerBuild={triggerBulkReScan}/>
    <SummaryComponent projectData={projectData}/>
    <div className="mr-controls">
        <button className="mr-btn" onClick={fetchOpenMRs} title="Fetch open Merge Requests from GitLab">
            Merge Requests
        </button>
    </div>
</div>
                <br></br>
                <div className="scans-table-container">
                <table border={1}>
                    <thead>
                        <tr>
                            <th>Select<br></br><input
                                type="checkbox"
                                checked={isSelectAllChecked}
                                onChange={handleSelectAllClick}
                            /></th>
                            <th onClick={() => handleSort('id')}>Project ID{renderSortIcon('id')}</th>
                            <th onClick={() => handleSort('project')}>Project{renderSortIcon('project')}</th>
                            <th onClick={() => handleSort('appstatus')}>Status{renderSortIcon('appstatus')}</th>
                            <th onClick={() => handleSort('creationDate')}>Report Date{renderSortIcon('creationDate')}</th>
                            <th onClick={() => handleSort('highCount')}>High{renderSortIcon('highCount')}</th>
                            <th onClick={() => handleSort('mediumCount')}>Medium{renderSortIcon('mediumCount')}</th>
                            <th onClick={() => handleSort('lowCount')}>Low{renderSortIcon('lowCount')}</th>
                            <th>Re-Scan</th>
                            <th>Fortify</th>
                            <th>Sonar</th>
                            <th>GIT</th>
                            {/* <th>FP</th> */}
                           
                            <th>Rancher</th>
                            <th>Kibana</th>
                            <th>Jenkins</th>
                           
                           
                        </tr>
                    </thead>
                    <tbody>
                        {sortData(
                            projectData
                                ?.filter(project => (
                                    (project?.name?.toLocaleLowerCase().includes(filter?.toLocaleLowerCase())
                                    || project?.configURLs?.value?.toLocaleLowerCase().includes(filter?.toLocaleLowerCase())
                                    || project?.configURLs?.endpoint?.toLocaleLowerCase().includes(filter?.toLocaleLowerCase()))
                                ))
                        )?.map((project, index) => {

                            
                            return (
                            <tr key={uuidv4()}>

                                <td>
                                    <input
                                        type="checkbox"
                                        checked={selectedRowIds.includes(project.id)}
                                        onChange={() => handleCheckboxClick(project.id)}
                                    />
                                </td>

                                <td>{project.id}</td>
                                <td><strong>{project?.configURLs?.value}</strong><br></br>{project.name}</td>


                                <td>
{project?.configURLs?.statusURL ? project?.appstatus=="UP"?(<>
    <div className="server-status-up">
    <span className="server-up"><button className={"play-button-active"}>&#128187;</button><br></br>{project?.freeMemoryPercentage||"UP"}</span>
  </div>
     
</>):(
<div className="server-status">
    <span className="server-down"><button className="play-button-down">&#128187;</button><br></br>DOWN</span>
  </div>) :

<button className={"play-button"}>&#128187;</button>
}
               
                           
</td>

                                <td className={new Date(project.creationDate)<new Date(new Date().setDate(new Date().getDate() - 21))
                                    ?'highCount':new Date(project.creationDate)<new Date(new Date().setDate(new Date().getDate() - 14))
                                    ?'mediumCount':new Date(project.creationDate)<new Date(new Date().setDate(new Date().getDate() - 7))
                                    ?'lowCount':'noCount'}>
                                    
                                    {new Date(project.creationDate)?.toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    second: '2-digit'
                                })}</td>

                                <td className={project.highCount > 0 ? 'highCount' : 'noCount'}>{project.highCount}</td>
                                <td className={project.mediumCount > 0 ? 'mediumCount' : 'noCount'}>{project.mediumCount}</td>
                                <td className={project.lowCount > 0 ? 'lowCount' : 'noCount'}>{project.lowCount}</td>
                                {/* <td className={project.fPCount > 0 ? 'fPCount' : 'noCount'}>{project.fPCount}</td> */}


                                <td>
                                    <button 
                                    className={project?.configURLs?.buildTriggerURL?"play-button-active":"play-button"}
                                     onClick={(e) => openReScan(e,project.id)}>&#x27F3;</button>
                                </td>


                                <td>
                                    <button 
                                    className="play-button-active"
                                     onClick={() => openFortifyPage(project.id)}>&#9888;</button>
                                </td>


                                <td>
                                      <a href={project?.configURLs?.sonarURL} target='_blank'>
                                  <button 
                                     className={project?.configURLs?.sonarURL?"play-button-active":"play-button"}>
                                      
                                      &#128295;</button></a>
                                </td>

                                <td> 
                                <a href={project?.configURLs?.gitUrl} target='_blank'>
                                  <button 
                                     className={project?.configURLs?.gitUrl?"play-button-active":"play-button"}>
                                        &#9998;</button></a>
                                </td>


                            
                               
                            

                                <td>
                                      <a href={project?.configURLs?.rancherURL} target='_blank'>
                                  <button 
                                     className={project?.configURLs?.rancherURL?"play-button-active":"play-button"}>
                                       &#9729;</button></a>
                                </td>

                               
                                {/* &#128269; */}
                                <td>
                                      <a href={project?.configURLs?.splunkURL} target='_blank'>
                                  <button 
                                     className={project?.configURLs?.splunkURL?"play-button-active":"play-button"}>
                                       &#128200;</button></a>
                                </td>

                                <td>
                               <a href={project?.configURLs?.jenkinURL} target='_blank'>
                                  <button 
                                     className={project?.configURLs?.jenkinURL?"play-button-active":"play-button"}
                                    //  onClick={(e) => project?.configURLs?.jenkinURL? openURL(e,project.id, "jenkins"):alert("Jenkins is not configured for this project")}
                                    >&#8521;</button></a>
                                </td>


                               

                            </tr>
                        )})

                        // ?.sort((a, b) => new Date(b.creationDate) - new Date(a.creationDate))
                        }
                    </tbody>
                </table>
                </div>
                <br></br>
            </div>

                        {/* Toast notifications */}
                        <div className="scans-toast-container">
                            {toasts.map((t) => (
                                <div key={t.id} className="scans-toast" role="status" aria-live="polite">
                                    <span className="toast-msg">{t.msg}</span>
                                    <button className="toast-close" aria-label="Dismiss notification" onClick={() => removeToast(t.id)}>×</button>
                                </div>
                            ))}
                        </div>

                        {/* Confirmation modal for bulk actions */}
                        {showConfirmBulk && (
                            <div className="scans-confirm-overlay" onClick={() => setShowConfirmBulk(false)}>
                                <div className="scans-confirm-modal" onClick={(e) => e.stopPropagation()}>
                                    <p>Proceed to Build & Re-Scan {selectedRowIds.length} selected project(s)?</p>
                                                        <div className="modal-actions">
                                                            <button onClick={runBulkReScan} className="modal-btn-confirm">Confirm</button>
                                                            <button onClick={() => setShowConfirmBulk(false)} className="modal-btn-cancel">Cancel</button>
                                                        </div>
                                </div>
                            </div>
                        )}

                        {showMRModal && (
                            <div className="scans-confirm-overlay" onClick={() => setShowMRModal(false)}>
                                <div className="scans-confirm-modal" onClick={(e) => e.stopPropagation()}>
                                    <p>Open Merge Requests in DOC-MANAGEMENT/apis ({mrOpenCount ?? (mrList?.length ?? 0)})</p>
                                    <div className="mr-list">
                                        {mrLoading ? (
                                            <p>Loading…</p>
                                        ) : mrList && mrList.length > 0 ? (
                                            <ul>
                                                {mrList.map((mr) => (
                                                    <li key={mr.id || mr?.iid || uuidv4()}>
                                                        <a href={(mr.web_url || mr?.webUrl)} target="_blank" rel="noopener noreferrer">
                                                            {mr.title || `MR ${mr?.iid}`}
                                                        </a>
                                                        {mr?.author?.name ? <span> — {mr.author.name}</span> : null}
                                                        {mr?.references?.full ? <span> — {mr.references.full}</span> : null}
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p>No open merge requests found.</p>
                                        )}
                                    </div>
                                    <div className="modal-actions">
                                        <a
                                            href="https://gitlab.us.bank-dns.com/groups/DOC-MANAGEMENT/apis/-/merge_requests"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="modal-btn-confirm"
                                        >Open in GitLab</a>
                                        <button onClick={() => setShowMRModal(false)} className="modal-btn-cancel">Close</button>
                                    </div>
                                </div>
                            </div>
                        )}

            {isEmailDivVisible && (
                <div ref={divRef} className="scans-email-overlay">


                    <br></br><br></br><br></br><br></br>
                    <div className="scans-table-container">
                    <table border={1}>
                        <thead>
                            <tr>
                                <th>{'Project'?.padEnd(65, '_')}</th>
                                <th>{'Report Date'?.padEnd(60, '_')}</th>
                                <th>{'High'}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {projectData?.filter(project => project.highCount > 0)?.sort((a, b) => new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime())?.map((project, index) => (
                                <tr key={index+"p"+project.id}>

                                    <td>{project.name?.padEnd(60, '_')}</td>

                                    <td>{new Date(project.creationDate)?.toLocaleDateString('en-US', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit'
                                    })?.padEnd(60, '_')}</td>

                                    <td className={project.highCount > 0 ? 'highCount' : 'noCount'}>{project.highCount}</td>


                                </tr>
                            ))}
                        </tbody>
                    </table>
                    </div>
                    <br></br>
                </div>
            )}

        </div>
    );
};

export default Scans;
